<template>
  <div class="border border-light-4 border-left-0 border-right-0">
    <div class="text-center py-space-lg py-lg-space-xl">
      <div class="img-quote mb-space-xxs">
        <img
          :src="quote"
          alt="quote"
          height="32"
          aria-hidden="true"
          focusable="false"
        />
      </div>
      <div
        class="mb-space-sm mb-lg-space-xs fs-xl fw-bold title-max-width mx-auto"
        v-html="props.title"
      ></div>
      <div class="line-separator mb-space-xxs bg-secondary mx-auto"></div>
      <h2 class="fs-small fw-bold mb-space-xxs">{{ props.author }}</h2>
      <div>{{ props.designation }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import quote from "~/assets/img/OpenQuote.svg?inline";

interface Props {
  title: string;
  author?: string;
  designation?: string;
}

const props = defineProps<Props>();
</script>

<style scoped lang="scss">
.line-separator {
  height: 4px;
  width: 64px;
}
@media (min-width: 992px) {
  .title-max-width {
    max-width: 445px;
  }
}
</style>
